import { sendTestEmail } from '../../../modules/emailTemplates/emailTemplates.repository';
import { TestEmail } from '../../../modules/emailTemplates/types';

export const sendTestEmailUseCase = (id: number, payload: TestEmail): Promise<void> => {
  return sendTestEmail(id, payload);
};